export const allowMotion = (): void => {
	document.documentElement.classList.remove( 'a11y-reduce-motion' );
};

export const reduceMotion = (): void => {
	document.documentElement.classList.add( 'a11y-reduce-motion' );
};

export const hasReducedMotion = (): boolean => {
	return document.documentElement.classList.contains( 'a11y-reduce-motion' );
};
